import {useEffect, useState} from 'react';

export const useCurrentTime = () => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(new Date());
        }, 30000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    return currentTime;
};
